
import { getDefaultConfig, Chain } from '@rainbow-me/rainbowkit';
//import { injected } from 'wagmi/connectors';
import { cookieStorage, createStorage } from 'wagmi'

export function getWagmiConfig(currencyID:number, chains:any){

	var chainSetOut = getChains(currencyID, chains);
  const wagmiConfig = getDefaultConfig({
      appName: 'Cues',
      projectId: '5117fc7203ae7d90e1941f473786e326',
      chains: chainSetOut,
      storage: createStorage({
        storage: cookieStorage
      })
  });

	return wagmiConfig;	
}

export function getChains(currencyID:number, chains:any){

  var chainSetOut = chains.filter((aChain:any, index:number) => {
    return currencyID === 0 || currencyID === -1 || aChain.ci === currencyID
  }).map((aChain:any, index : number)=>{

    // if (currencyID === 1116){
    //   return {id:1116, name:'Core Blockchain Mainnet', nativeCurrency:{decimals:18, name:'CORE', symbol: 'CORE'}, rpcUrls:{default:{http:['https://rpc.coredao.org']}, public: {http:['https://rpc.coredao.org']}}, blockExplorers:{etherscan:{name:'',url:'https://scan.coredao.org'}, default:{name:'scan', url:'https://scan.coredao.org'}}};
    // if (currencyID === 80002){
    //   return {id:80002, name:'Polygon Amoy Testnet', nativeCurrency:{decimals:18, name:'MATIC', symbol: 'MATIC'}, rpcUrls:{default:{http:['https://rpc-amoy.polygon.technology']}, public: {http:['https://rpc-amoy.polygon.technology']}}, blockExplorers:{etherscan:{name:'',url:'https://amoy.polygonscan.com'}, default:{name:'scan', url:'https://amoy.polygonscan.com'}}};
    // }else{
    var a = {id:aChain.ci, name:aChain.c, nativeCurrency:{decimals:aChain.d, name:aChain.i, symbol:aChain.i}, rpcUrls:{default:{http:[aChain.r]}, public: {http:[aChain.r]}}, blockExplorers:{etherscan:{name:'',url:aChain.b[0]}, default:{name:'scan', url:aChain.b[0]}}}
    // console.log(a)
      return a;

    //   return {"id":aChain.ci,"name":aChain.c,"network":aChain.network,"nativeCurrency":{"decimals":aChain.d,"name":aChain.i,"symbol":aChain.i},"rpcUrls":{"default":{"http":aChain.r},"public":{"http":aChain.r}},"blockExplorers":{"etherscan":{"name":aChain.sN,"url":aChain.b[0]},"default":{"name":aChain.sN,"url":aChain.b[0]}},"contracts":{"multicall3":{"address":aChain.multiAdd,"blockCreated":aChain.multiBlock}}};

    // }
  })

  if (chainSetOut.length === 0){
    var bscT = {id:97, name:'Binance Smart Chain Testnet', nativeCurrency:{decimals:18, name:'tBNB', symbol: 'tBNB'}, rpcUrls:{default:{http:['https://data-seed-prebsc-1-s1.binance.org:8545']}, public: {http:['https://data-seed-prebsc-1-s1.binance.org:8545']}}, blockExplorers:{etherscan:{name:'BscScan',url:'https://testnet.bscscan.com'}, default:{name:'BscScan', url:'https://testnet.bscscan.com'}}, contracts:{ multicall3:{address:'0xca11bde05977b3631167028862be2a173976ca11', blockCreated:17422483}}} as const satisfies Chain;

    chainSetOut.push(bscT)
  }

  return chainSetOut;

}

export function getContract(chainInfo:any){

}